import React, { useMemo } from "react";
import { useCountriesUIContext } from "../CountriesUIContext";

export function CountriesGrouping() {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      setIds: countriesUIContext.setIds,
      openDeleteCountriesDialog: countriesUIContext.openDeleteCountriesDialog,
      openFetchCountriesDialog: countriesUIContext.openFetchCountriesDialog,
      openUpdateCountriesStatusDialog:
        countriesUIContext.openUpdateCountriesStatusDialog,
    };
  }, [countriesUIContext]);

  return (
    <div className="form mb-4">
      <div className="card card-custom bg-light border-0 py-3 px-6 d-flex flex-row align-items-center justify-content-between flex-wrap shadow-xs">
        <div className="d-flex align-items-center my-1 mr-4" style={{ gap: "10px" }}>
          <span className="font-weight-bolder font-size-sm" style={{ color: "#181C32", marginRight: "8px" }}>
            Selected Countries:
          </span>
          <span
            className="label label-primary label-inline font-weight-bolder font-size-sm py-2 px-3"
            style={{ backgroundColor: "#3699FF", color: "#ffffff", minWidth: "36px", textAlign: "center", borderRadius: "6px" }}
          >
            {countriesUIProps.ids.length}
          </span>
        </div>
        <div className="d-flex align-items-center my-1" style={{ gap: "8px" }}>
          <button
            type="button"
            className="btn btn-light-primary font-weight-bolder font-size-sm"
            onClick={countriesUIProps.openUpdateCountriesStatusDialog}
          >
            <i className="fa fa-sync-alt mr-1"></i> Update Status
          </button>
          <button
            type="button"
            className="btn btn-light-danger font-weight-bolder font-size-sm"
            onClick={countriesUIProps.openDeleteCountriesDialog}
          >
            <i className="fa fa-trash mr-1"></i> Delete Selected
          </button>
        </div>
      </div>
    </div>
  );
}
